import { render, staticRenderFns } from "./complaint.vue?vue&type=template&id=41301956"
import script from "./complaint.vue?vue&type=script&lang=js"
export * from "./complaint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41301956')) {
      api.createRecord('41301956', component.options)
    } else {
      api.reload('41301956', component.options)
    }
    module.hot.accept("./complaint.vue?vue&type=template&id=41301956", function () {
      api.rerender('41301956', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/complaint/complaint.vue"
export default component.exports